import { ReactNode } from 'react'

import { WizardStepPill } from './WizardStepPill'

interface Props {
  stepNumber: number
  totalSteps: number
  title: string
  badge?: ReactNode
  description?: ReactNode
  rightSlot?: ReactNode
}

export function WizardStepHeader({
  stepNumber,
  totalSteps,
  title,
  badge,
  description,
  rightSlot,
}: Props) {
  return (
    <div className="flex h-28 items-center border-b border-line bg-surface px-8">
      <div className="flex w-full items-start justify-between gap-4">
        <div>
          <WizardStepPill stepNumber={stepNumber} totalSteps={totalSteps} />
          <div className="flex items-center gap-2">
            <h1 className="text-xl font-semibold text-fg">{title}</h1>
            {badge}
          </div>
          {description && (
            <p className="mt-1 text-sm text-fg-secondary">{description}</p>
          )}
        </div>
        {rightSlot}
      </div>
    </div>
  )
}
